import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/reset-password/reset-password.component').then((c) => c.ResetPasswordComponent),
  },
  {
    path: 'google-cb',
    loadComponent: () =>
      import('./features/settings/pages/google-callback/google-callback.component').then((c) => c.GoogleCallbackComponent),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then((c) => c.DashboardComponent),
      },
      {
        path: 'reports/client-report',
        loadComponent: () => import('./features/dashboard/components/client-report/client-report.component').then((c) => c.ClientReportComponent),
      },
      {
        path: 'reports/sales-report',
        loadComponent: () => import('./features/dashboard/components/sales-report/sales-report.component').then((c) => c.SalesReportComponent),
      },
      {
        path: 'reports/broker-performance',
        loadComponent: () => import('./features/dashboard/components/broker-performance/broker-performance.component').then((c) => c.BrokerPerformanceComponent),
      },
      {
        path: 'leads',
        loadChildren: () => import('./features/leads/leads.routes').then((r) => r.LEADS_ROUTES),
      },
      {
        path: 'opportunities',
        loadChildren: () => import('./features/opportunities/opportunities.routes').then(r => r.OPPORTUNITIES_ROUTES),
      },
      {
        path: 'tasks',
        loadChildren: () => import('./features/tasks/tasks.routes').then(r => r.TASKS_ROUTES),
      },
      {
        path: 'clients',
        loadChildren: () => import('./features/clients/clients.routes').then(r => r.CLIENTS_ROUTES),
      },
      {
        path: 'appointments',
        loadChildren: () => import('./features/appointments/appointments.routes').then(r => r.APPOINTMENT_ROUTES),
      },
      {
        path: 'email-templates',
        loadChildren: () => import('./features/emails/emails.routes').then(r => r.EMAIL_TEMPLATE_ROUTES),
      },
      {
        path: 'products',
        canActivate: [roleGuard],
        data: { expectedRoles: ['ADMIN'], allowDepartmentHead: true },
        loadChildren: () => import('./features/products/products.routes').then(r => r.PRODUCTS_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then(r => r.SETTINGS_ROUTES),
      },
      {
        path: '',
        redirectTo: 'tasks',
        pathMatch: 'full',
      },
    ],
  },
  // Optional: A general fallback route
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }